import React, { useState } from "react";
import "./praxis.css";
import "./embla.css"
import EmblaCarousel from "./emblaCarousel"


const OPTIONS = { dragFree: true, loop: true }
const SLIDE_COUNT = 5
const SLIDES = Array.from(Array(SLIDE_COUNT).keys())


const Praxis = () => {

/* Pop Up States */
const [isOpen2, setIsOpen] = useState(false);
const [isClosing, setIsClosing] = useState(false);

const openPopup = () => {
setIsOpen(true);
setIsClosing(false);
};

const closePopup = () => {
setIsClosing(true);

    setTimeout(() => {
        setIsOpen(false);
        setIsClosing(false);
    }, 300); // muss zur CSS-Animation passen
};

    return (
        <>
            <div className="praxis_headline">
                <div className="praxis__headline">
                    <h1> Einblicke in unsere KFO-Praxis </h1>
                </div>
            </div>

            <div className="praxis__intro">
                <div className="praxis___intro">
                    <div className="praxis____intro">
                        <p>
                            Unsere Praxis verfügt über modernste technische Ausstattungen.
                            Mit unserer digitalen Röntgenanlage haben wir optimale Diagnosemöglichkeiten
                            bei minimaler Strahlenbelastung. Mittels unseres Intraoralscanners ist es oft möglich,
                            ganz auf konventionelle Abdrücke mit herkömmlicher Abdruckmasse zu verzichten.
                        </p>
                    </div>
                </div>
            </div>

            <EmblaCarousel slides={SLIDES} options={OPTIONS} />

            <div className="genContainerFooter">
                <div className="genContainerFooter_inner">
                    <p>
                        Termine können einfach und schnell auch online gebucht werden <br></br>

                        <button title="Onlinetermine" className="praxis_btn" onClick={openPopup}>
                                <div className="onlineTxtDiv">
                                <span> Beratungstermin buchen </span>
                                </div>
                        </button>

                    </p>
                </div>
            </div >

            {isOpen2 && (
                <div className={`popupOverlay ${isClosing ? "closing" : ""}`} onClick={closePopup}>
                    <div className={`popupContent ${isClosing ? "closing" : ""}`} onClick={(e) => e.stopPropagation()}>
                    
                        <button className="closeBtn" onClick={closePopup}>
                            ✕
                        </button>

                        <h2>Nur für Neupatienten</h2>

                        <br></br>

                        <p>
                            Nach Ihrer Online-Terminbuchung erhalten Sie einen Anamnesebogen per E-Mail.
                           Bitte füllen Sie diesen umgehend vollständig aus und senden ihn an uns zurück, da der Termin andernfalls storniert wird.
                        </p>

                        <a href="https://iie-systems.de/online-termin-kfo-medefindt" target="_blank" rel="noreferrer" className="popupBtn">
                            Bestätigen und zur Terminbuchung
                        </a>

                    </div>
                </div>
            )}

        </>
    )
}

export default Praxis